import * as React from 'react';

import classNames from 'classnames';

interface ILevelProps {
	className?: string;
}

export default class Level extends React.Component<ILevelProps, {}> {
	public render() {
		const { className } = this.props;
		const classes = classNames('level', className ? className : '');

		return <div className={classes}>{this.props.children}</div>;
	}
}
